module.exports = __webpack_public_path__ + "static/uncovering-memories-from-world-war-ii-502036f3905d2c4dcae988bba79255cd.jpg";